import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "webhooks-filters-editor-visual" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" ")
const _hoisted_3 = {
  key: 1,
  class: "label-m"
}
const _hoisted_4 = {
  key: 1,
  class: "webhooks-filters-editor-visual__default"
}
const _hoisted_5 = { class: "label-m webhooks-filters-editor-visual__default-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WebhooksFiltersDivider = _resolveComponent("WebhooksFiltersDivider")!
  const _component_FiltersSmall = _resolveComponent("FiltersSmall")!
  const _component_NThemeImage = _resolveComponent("NThemeImage")!
  const _component_WebhooksFiltersEditorVisualBig = _resolveComponent("WebhooksFiltersEditorVisualBig")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.hasChanges)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.activeSections, (section) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "webhooks-filters-editor-visual__section-small",
            key: section
          }, [
            _createVNode(_component_WebhooksFiltersDivider, {
              class: "webhooks-divider-small",
              label: _ctx.$t(`webhooks.section_${section}`, 'f')
            }, null, 8, ["label"]),
            (_ctx.isSectionHasFilters(_ctx.modelValue[section]))
              ? (_openBlock(), _createBlock(_component_FiltersSmall, {
                  key: 0,
                  "form-layout": _ctx.smallFiltersLayout[section],
                  "model-value": _ctx.modelValue[section],
                  disabled: _ctx.disabled
                }, {
                  actions: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 2
                }, 1032, ["form-layout", "model-value", "disabled"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.$t('webhooks.section_selected')) + " " + _toDisplayString(_ctx.$t(`webhooks.section_${section}`)), 1))
          ]))
        }), 128))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_NThemeImage, { "css-var": "--image-webhooks-hooks-filter-default" }),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.filterDefaultI18n), 1)
        ])),
    (_ctx.largeFiltersActive)
      ? (_openBlock(), _createBlock(_component_WebhooksFiltersEditorVisualBig, {
          key: 2,
          "form-layout": _ctx.largeFiltersLayout,
          "model-value": _ctx.modelValue,
          sections: _ctx.sections,
          multiple: _ctx.multiple,
          "onUpdate:modelValue": _ctx.emitModelUpdate,
          onReset: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reset'))),
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, null, 8, ["form-layout", "model-value", "sections", "multiple", "onUpdate:modelValue"]))
      : _createCommentVNode("", true)
  ]))
}